// Pokeru Theme — theme.js

document.addEventListener('DOMContentLoaded', function () {

  // ── Scroll lock (iOS-safe) ──
  var scrollY = 0;
  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  // ── Hamburger menu ──
  var hamburgerBtn = document.querySelector('.hamburger-btn');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    if (hamburgerBtn) hamburgerBtn.classList.add('open');
    if (mobileNav) mobileNav.classList.add('open');
    lockScroll();
  }
  function closeMobileNav() {
    if (hamburgerBtn) hamburgerBtn.classList.remove('open');
    if (mobileNav) mobileNav.classList.remove('open');
    unlockScroll();
  }

  if (hamburgerBtn) hamburgerBtn.addEventListener('click', function () {
    mobileNav && mobileNav.classList.contains('open') ? closeMobileNav() : openMobileNav();
  });
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobileNav);
    });
  }

  // ── Mobile fullscreen search overlay ──
  var searchMobileBtn = document.getElementById('searchMobileBtn');
  var mobileSearchOverlay = document.getElementById('mobileSearchOverlay');
  var mobileSearchOverlayInput = document.getElementById('mobileSearchOverlayInput');
  var mobileSearchOverlayClear = document.getElementById('mobileSearchOverlayClear');
  var mobileSearchOverlayResults = document.getElementById('mobileSearchOverlayResults');
  var mobileSearchOverlayClose = document.getElementById('mobileSearchOverlayClose');

  function openMobileSearch() {
    if (!mobileSearchOverlay) return;
    mobileSearchOverlay.classList.add('open');
    lockScroll();
    setTimeout(function () {
      if (mobileSearchOverlayInput) mobileSearchOverlayInput.focus();
    }, 100);
  }

  function closeMobileSearch() {
    if (!mobileSearchOverlay) return;
    mobileSearchOverlay.classList.remove('open');
    unlockScroll();
    if (mobileSearchOverlayInput) mobileSearchOverlayInput.value = '';
    if (mobileSearchOverlayClear) mobileSearchOverlayClear.style.display = 'none';
    if (mobileSearchOverlayResults) mobileSearchOverlayResults.innerHTML = '';
  }

  if (searchMobileBtn) searchMobileBtn.addEventListener('click', openMobileSearch);
  if (mobileSearchOverlayClose) mobileSearchOverlayClose.addEventListener('click', closeMobileSearch);

  if (mobileSearchOverlayInput) {
    var overlayDelay;
    mobileSearchOverlayInput.addEventListener('input', function () {
      var q = this.value.trim();
      if (mobileSearchOverlayClear) mobileSearchOverlayClear.style.display = q.length > 0 ? 'block' : 'none';
      clearTimeout(overlayDelay);
      if (q.length < 2) { mobileSearchOverlayResults.innerHTML = ''; return; }
      mobileSearchOverlayResults.innerHTML = '<div class="search-status">Searching...</div>';
      overlayDelay = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = data.resources && data.resources.results && data.resources.results.products
              ? data.resources.results.products : [];
            if (!items.length) {
              mobileSearchOverlayResults.innerHTML = '<div class="search-status">No results for "' + q + '"</div>';
              return;
            }
            var html = '';
            items.forEach(function (item) {
              var img = item.featured_image
                ? '<img class="search-result-img" src="' + item.featured_image.url + '" alt="' + (item.featured_image.alt || item.title) + '">'
                : '<div class="search-result-img-placeholder">ポケ</div>';
              var price = item.price !== undefined ? formatMoney(item.price) : '';
              html += '<a class="search-result-item" href="' + item.url + '">'
                + img
                + '<div>'
                + '<div class="search-result-name">' + item.title + '</div>'
                + '<div class="search-result-price">' + price + '</div>'
                + '</div>'
                + '</a>';
            });
            html += '<div class="search-footer"><a href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results</a></div>';
            mobileSearchOverlayResults.innerHTML = html;
          })
          .catch(function () {
            mobileSearchOverlayResults.innerHTML = '<div class="search-status">Something went wrong. Try again.</div>';
          });
      }, 280);
    });
    mobileSearchOverlayInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && this.value.trim().length > 0) {
        window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product';
      }
      if (e.key === 'Escape') closeMobileSearch();
    });
  }

  if (mobileSearchOverlayClear) {
    mobileSearchOverlayClear.addEventListener('click', function () {
      if (mobileSearchOverlayInput) mobileSearchOverlayInput.value = '';
      this.style.display = 'none';
      if (mobileSearchOverlayResults) mobileSearchOverlayResults.innerHTML = '';
      if (mobileSearchOverlayInput) mobileSearchOverlayInput.focus();
    });
  }

  // ── Predictive Search ──
  var searchDelay;

  function formatMoney(amount) {
    var format = window.PokeruMoneyFormat || '${{amount}}';
    function formatWithDelimiters(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      n = parseFloat(n).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision > 0 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var type = match ? match[1] : 'amount';
    var value;
    switch (type) {
      case 'amount':                                  value = formatWithDelimiters(amount, 2); break;
      case 'amount_no_decimals':                      value = formatWithDelimiters(amount, 0); break;
      case 'amount_with_comma_separator':             value = formatWithDelimiters(amount, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(amount, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(amount, 0, ' '); break;
      default:                                        value = formatWithDelimiters(amount, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function renderResults(items, dropdownEl, query) {
    if (!items || items.length === 0) {
      dropdownEl.innerHTML = '<div class="search-status">No results for "' + query + '"</div>';
      dropdownEl.classList.add('open');
      return;
    }
    var html = '';
    items.forEach(function (item) {
      var img = item.featured_image
        ? '<img class="search-result-img" src="' + item.featured_image.url + '" alt="' + (item.featured_image.alt || item.title) + '">'
        : '<div class="search-result-img-placeholder">ポケ</div>';
      var price = item.price !== undefined ? formatMoney(item.price) : '';
      html += '<a class="search-result-item" href="' + item.url + '">'
        + img
        + '<div>'
        + '<div class="search-result-name">' + item.title + '</div>'
        + '<div class="search-result-price">' + price + '</div>'
        + '</div>'
        + '</a>';
    });
    html += '<div class="search-footer"><a href="/search?q=' + encodeURIComponent(query) + '&type=product">See all results</a></div>';
    dropdownEl.innerHTML = html;
    dropdownEl.classList.add('open');
  }

  function clearDropdown(dropdownEl) {
    dropdownEl.classList.remove('open');
    dropdownEl.innerHTML = '';
  }

  function doSearch(query, dropdownEl) {
    if (query.length < 2) { clearDropdown(dropdownEl); return; }
    dropdownEl.innerHTML = '<div class="search-status">Searching...</div>';
    dropdownEl.classList.add('open');
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products : [];
        renderResults(items, dropdownEl, query);
      })
      .catch(function () {
        dropdownEl.innerHTML = '<div class="search-status">Something went wrong. Try again.</div>';
      });
  }

  function initSearch(inputEl, clearBtn, dropdownEl) {
    if (!inputEl) return;
    var icon = inputEl.closest('.search-field') && inputEl.closest('.search-field').querySelector('.search-icon');
    if (icon) icon.addEventListener('click', function () { inputEl.focus(); });

    inputEl.addEventListener('input', function () {
      var q = this.value.trim();
      if (clearBtn) clearBtn.style.display = q.length > 0 ? 'block' : 'none';
      clearTimeout(searchDelay);
      searchDelay = setTimeout(function () { doSearch(q, dropdownEl); }, 280);
    });
    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        this.value = '';
        if (clearBtn) clearBtn.style.display = 'none';
        clearDropdown(dropdownEl);
        this.blur();
      }
      if (e.key === 'Enter' && this.value.trim().length > 0) {
        window.location.href = '/search?q=' + encodeURIComponent(this.value.trim()) + '&type=product';
      }
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        inputEl.value = '';
        this.style.display = 'none';
        clearDropdown(dropdownEl);
        inputEl.focus();
      });
    }
    inputEl.addEventListener('blur', function () {
      setTimeout(function () {
        if (clearBtn) clearBtn.style.display = 'none';
      }, 200);
    });
    inputEl.addEventListener('focus', function () {
      if (this.value.trim().length > 0 && clearBtn) clearBtn.style.display = 'block';
    });
    document.addEventListener('click', function (e) {
      var wrap = inputEl.closest('.search-wrap') || inputEl.closest('.mobile-search-wrap');
      if (wrap && !wrap.contains(e.target)) clearDropdown(dropdownEl);
    });
  }

  initSearch(
    document.getElementById('searchInput'),
    document.getElementById('searchClear'),
    document.getElementById('searchDropdown')
  );
  initSearch(
    document.getElementById('mobileSearchInput'),
    document.getElementById('mobileSearchClear'),
    document.getElementById('mobileSearchDropdown')
  );

  // ── PDP tabs ──
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
      var content = document.getElementById('tab-' + target);
      if (content) content.classList.add('active');
    });
  });

  // ── PDP thumbnails ──
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.dataset.src;
      var mainImg = document.querySelector('.pdp-main-img');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // ── Product Carousel ──
  document.querySelectorAll('.product-carousel-wrap').forEach(function (wrap) {
    var carousel = wrap.querySelector('.product-carousel');
    var prevBtn = wrap.querySelector('.carousel-btn--prev');
    var nextBtn = wrap.querySelector('.carousel-btn--next');

    if (!carousel) return;

    function getScrollAmount() {
      var item = carousel.querySelector('.product-carousel-item');
      var gap = window.innerWidth > 900 ? 24 : 10;
      var single = item ? item.offsetWidth + gap : 300;
      return window.innerWidth > 900 ? single * 2 : single;
    }

    function updateButtons() {
      var atStart = carousel.scrollLeft <= 2;
      var atEnd = carousel.scrollLeft >= carousel.scrollWidth - carousel.offsetWidth - 10;
      if (prevBtn) prevBtn.classList.toggle('is-hidden', atStart);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', atEnd);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    carousel.addEventListener('scroll', updateButtons);
    updateButtons();

    // Mouse drag to scroll
    var isDragging = false;
    var startX, scrollStart;
    carousel.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollStart = carousel.scrollLeft;
      carousel.classList.add('is-dragging');
    });
    document.addEventListener('mouseup', function () {
      isDragging = false;
      carousel.classList.remove('is-dragging');
    });
    carousel.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      carousel.scrollLeft = scrollStart - (x - startX);
    });
    carousel.addEventListener('mouseleave', function () {
      isDragging = false;
      carousel.classList.remove('is-dragging');
    });
  });

  // ── Filter pills ──
  document.querySelectorAll('.filter-pill[data-tag]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var tag = this.dataset.tag;
      var base = window.location.pathname.split('/tagged/')[0];
      window.location.href = tag === 'all' ? base : base + '/tagged/' + tag;
    });
  });

  // ── Cart count ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
      })
      .catch(function () {});
  }
  updateCartCount();

  // ── PDP inventory enforcement ──
  // Saves original total inventory on the qty input so remaining = total - cart_qty stays accurate.
  var pdpQtyInput = document.getElementById('qtyInput');
  if (pdpQtyInput && !pdpQtyInput.dataset.inventoryMax) {
    pdpQtyInput.dataset.inventoryMax = pdpQtyInput.max;
  }

  function updatePdpEffectiveMax() {
    var qtyInput = document.getElementById('qtyInput');
    if (!qtyInput) return;
    var inventoryMax = parseInt(qtyInput.dataset.inventoryMax || qtyInput.max);
    if (isNaN(inventoryMax) || inventoryMax <= 0 || inventoryMax >= 99) return;

    var atcForm = qtyInput.closest('form');
    var variantInput = atcForm && atcForm.querySelector('[name="id"]');
    var variantId = variantInput ? parseInt(variantInput.value) : null;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartQty = 0;
        if (variantId) {
          cart.items.forEach(function (item) {
            if (item.variant_id === variantId) cartQty += item.quantity;
          });
        }
        var remaining = Math.max(0, inventoryMax - cartQty);
        qtyInput.max = remaining;

        var currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal > remaining) qtyInput.value = Math.max(1, remaining);

        var plusBtn  = document.getElementById('qtyPlus');
        var minusBtn = document.getElementById('qtyMinus');
        var atcBtn   = document.getElementById('pdpAtcBtn');
        var stickyBtn = document.getElementById('pdpStickyAtc');

        if (remaining <= 0) {
          if (qtyInput)  { qtyInput.disabled = true; qtyInput.value = 0; }
          if (plusBtn)   plusBtn.disabled = true;
          if (minusBtn)  minusBtn.disabled = true;
          if (atcBtn)    { atcBtn.disabled = true; atcBtn.textContent = 'Max in Cart'; }
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Max in Cart'; }
        } else {
          if (plusBtn)  plusBtn.disabled  = (currentVal >= remaining);
          if (minusBtn) minusBtn.disabled = (currentVal <= 1);
        }
      })
      .catch(function () {});
  }

  if (pdpQtyInput) updatePdpEffectiveMax();

  // ── AJAX Add to Cart ──
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;

    // Safety guard: abort if inventory already exhausted
    var pdpGuard = form.querySelector('#qtyInput');
    if (pdpGuard && parseInt(pdpGuard.max) <= 0) {
      updatePdpEffectiveMax();
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = originalText;
          btn.disabled = false;
        } else {
          btn.textContent = 'Added ✓';
          btn.classList.add('btn-atc--added');
          updateCartCount();
          updatePdpEffectiveMax();
          setTimeout(function () {
            btn.classList.remove('btn-atc--added');
            var qtyInputEl = document.getElementById('qtyInput');
            var remaining = qtyInputEl ? parseInt(qtyInputEl.max) : NaN;
            if (isNaN(remaining) || remaining > 0) {
              btn.textContent = originalText;
              btn.disabled = false;
            }
            // If remaining = 0, updatePdpEffectiveMax already set the button to 'Max in Cart' + disabled
          }, 2000);
        }
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  // ── AJAX Cart Change (cart page qty +/-/remove) ──
  document.addEventListener('click', function (e) {
    var btn = e.target;
    var qtyRow = btn.closest && btn.closest('.cart-item-qty');
    if (!qtyRow) return;
    var isMinus  = btn.classList.contains('cart-qty-btn--minus');
    var isPlus   = btn.classList.contains('cart-qty-btn--plus');
    var isRemove = btn.classList.contains('cart-remove-btn');
    if (!isMinus && !isPlus && !isRemove) return;

    var key = qtyRow.dataset.key;
    var qtyDisplay = qtyRow.querySelector('.cart-qty-count');
    var currentQty = parseInt(qtyDisplay ? qtyDisplay.textContent : 1) || 1;
    var newQty = isRemove ? 0 : (isPlus ? currentQty + 1 : Math.max(0, currentQty - 1));

    var cartItem = qtyRow.closest('.cart-item');
    var rowBtns = qtyRow.querySelectorAll('button');
    rowBtns.forEach(function (b) { b.disabled = true; });

    var errorEl = cartItem && cartItem.querySelector('.cart-qty-error');
    if (errorEl) errorEl.textContent = '';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'id=' + encodeURIComponent(key) + '&quantity=' + newQty
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        rowBtns.forEach(function (b) { b.disabled = false; });

        if (data.status) {
          if (!errorEl && cartItem) {
            errorEl = document.createElement('div');
            errorEl.className = 'cart-qty-error';
            qtyRow.insertAdjacentElement('afterend', errorEl);
          }
          if (errorEl) {
            errorEl.textContent = data.description || 'Could not update quantity.';
            setTimeout(function () { if (errorEl) errorEl.textContent = ''; }, 4000);
          }
          return;
        }

        if (newQty === 0) {
          if (cartItem) cartItem.remove();
          if (!document.querySelector('.cart-item')) location.reload();
          return;
        }

        if (qtyDisplay) qtyDisplay.textContent = newQty;

        var lineItem = null;
        if (data.items) {
          data.items.forEach(function (item) { if (item.key === key) lineItem = item; });
        }
        if (lineItem && cartItem) {
          var priceEl = cartItem.querySelector('.cart-item-price-main');
          var unitEl  = cartItem.querySelector('.cart-item-price-unit');
          if (priceEl) priceEl.textContent = formatMoney(lineItem.line_price / 100);
          if (unitEl)  unitEl.textContent  = formatMoney(lineItem.price / 100) + ' each';
        }

        var subtotalEl = document.getElementById('cart-subtotal-price');
        var totalEl    = document.getElementById('cart-total-price');
        if (subtotalEl) subtotalEl.textContent = formatMoney(data.total_price / 100);
        if (totalEl)    totalEl.textContent    = formatMoney(data.total_price / 100) + ' ' + (data.currency || '');

        updateCartCount();
      })
      .catch(function () {
        rowBtns.forEach(function (b) { b.disabled = false; });
      });
  });

  // ── Plaster texture ──
  var textureUrl = 'https://cdn.shopify.com/s/files/1/0720/4313/5064/files/fan_plaster_background.png?v=1776773367';
  var isMobile = window.innerWidth <= 900;
  function applyTexture(el) {
    if (isMobile && el !== document.body) return;
    el.style.backgroundImage = 'url(' + textureUrl + ')';
    if (isMobile) {
      el.style.backgroundSize = '400px';
      el.style.backgroundRepeat = 'repeat';
      el.style.backgroundAttachment = 'scroll';
      el.style.backgroundPosition = 'top left';
    } else {
      el.style.backgroundSize = '600px';
      el.style.backgroundRepeat = 'repeat';
      el.style.backgroundAttachment = 'fixed';
      el.style.backgroundPosition = 'top left';
    }
  }
  applyTexture(document.body);
  document.querySelectorAll('.washi-bg').forEach(applyTexture);

  // Inject breadcrumb on policy pages
  const policyContainer = document.querySelector('.shopify-policy__container');
  if (policyContainer) {
    const crumb = document.createElement('nav');
    crumb.className = 'shopify-policy__breadcrumb';
    crumb.innerHTML = '<a href="/">Home</a><span class="shopify-policy__breadcrumb-divider">›</span><span class="shopify-policy__breadcrumb-current">' + document.querySelector('.shopify-policy__title h1').textContent + '</span>';
    policyContainer.insertBefore(crumb, policyContainer.firstChild);
  }

});